<div class="row mt-1 justify-content-between ">
    <div class="col-auto">
      <h1 class="text mt-3 pl-4 tittleDash">Dashboard</h1>
    </div>
    <div class="col-auto mt-4">
      <button (click)="addNewKPI()" class="btnPlusAdd">
        <i class="fas fa-plus-circle"></i>
      </button>
    </div>
  </div>